const MAX_LENGTH_CONSTRAINTS = {
  LOCATION_NAME: 30
};

const FORM_VALIDATION_MSG = {
  REQUIRED: '* Required',
  MAX_LENGTH_EXCEEDED: '* Max length exceeded',
  MATCHED_LOCATION: 'Location name already exist'
};

const API_STATUS_MSG = {
  UPDATE_SUCCESS: 'Location mapping area saved successfully',
  UPDATE_FAILED: 'Error while saving location mapping area',
  DELETE_SUCCESS: 'Location deleted successfully',
  DELETE_FAILED: 'Failed to delete location',
  FETCH_FAILED: 'Failed to load location mapping data',
}

const LOCATION_TAB = {
  EQUIPMENT: 0,
  DOW_DELIVERY: 1
};

export { MAX_LENGTH_CONSTRAINTS, FORM_VALIDATION_MSG, API_STATUS_MSG, LOCATION_TAB };
